<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-arrow-left-right">&nbsp; Transfers Orders</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadTransferOrders()" :disabled="isBusy || loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->          
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="branch" @change="branchChanged()" :disabled="isBusy || loading">
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        
        <div class="col">
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-10">Time</th>
          <th class="w-15">From</th>
          <th class="w-15">To</th>
          <th class="">Items</th>
          <th class="w-10 text-center">state</th>
          <th class="w-5 text-center">Fees</th>
          <th class="text-center w-15"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">
        <LoadingRow v-if="isBusy"></LoadingRow>
        
        <tr v-for="transfer in transferOrders" :key="transfer._id" v-bind:class="{'pending': 'table-warning', 'delivered': 'table-success', 'rejected': 'table-danger'}[transfer.state]" >
          <td class="w-10">{{ transfer.date }}</td>
          <td class="w-15">{{ transfer.src_branch }}</td>
          <td class="w-15">{{ transfer.dst_branch }}</td>
          <td class="">
            <table class="table table-sm table-bordered">
              <tbody>
                <tr v-for="item in transfer.items" :key="item._id">
                  <td class="w-75">{{ item.name }}</td>
                  <td class="w-15 text-center">{{ item.prod_date }}</td>
                  <td class="w-10 text-center">{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="w-10 text-center">
            {{ transfer.state }}
            <div v-if="transfer.state != 'pending'">
              {{ transfer.date2 }}
            </div>
          </td>
          <td class="text-center w-5">{{ transfer.fees }}</td>
          <td class="text-center w-15">
            <div v-if="transfer.state == 'pending'" >
              <button class="btn btn-success bi-check-lg w-100 mb-2" :disabled="loading" @click="transferModal(transfer._id)">&nbsp; Action</button>
              <br>
            </div>
            <button class="btn btn-warning bi-printer-fill w-100" :disabled="loading" @click="viewReceipt(transfer._id)">&nbsp; Print</button>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="transferModal" ref="transferModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Transfer: {{ currTransfer._id }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Source</span>
              <span class="input-group-text w-75">{{ currTransfer.src_branch }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Destination</span>
              <span class="input-group-text w-75">{{ currTransfer.dst_branch }}</span>
            </div>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-secondary text-bold">
                  <td class="w-65">Item</td>
                  <td class="w-20 text-center">Prod Date</td>
                  <td class="w-15 text-center">Quantity</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in currTransfer.items" :key="item._id">
                  <td class="w-65">{{ item.name }}</td>
                  <td class="w-20 text-center">{{ item.prod_date }}</td>
                  <td class="w-15 text-center">{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Driver</span>
              <span class="input-group-text w-75">{{ currTransfer.driver }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Truck</span>
              <span class="input-group-text w-75">{{ currTransfer.truck }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Fees</span>
              <span class="input-group-text w-75">{{ currTransfer.fees }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Notes</span>
              <input class="form-control" type="text" v-model.trim="currTransfer.notes">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-danger w-100" @click="rejectTransfer()">Reject</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="acceptTransfer()">Accept</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>

  </div>
  <TransferReceipt ref="transfer_receipt"></TransferReceipt>

</template>
<!-- ******************************************************** -->
<script>
import TransferReceipt from '@/components/TransferReceipt.vue';

  const $ = require('jquery');
  export default {
    name: 'transferOrders',
    components: {
      TransferReceipt,
    },
    data(){
      return {
        loading: false,
        isBusy: false,
        branches: [],
        transferOrders: [],
        branch: '*',
        currTransfer: {
          _id: '',
          src_branch: '',
          dst_branch: '',
          date: '',
          driver: '',
          truck: '',
          fees: '',
          notes: '',
        },
      }
    },
    async created() {
      await this.loadBranches();
      if(this.branches.length > 1) this.branch = this.branches[0]._id;
      this.loadTransferOrders();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.isBusy = true;
        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.isBusy = false;
      },
      //**********************************************************
      async loadTransferOrders(){
        this.isBusy = true;
        this.transferOrders = [];
        var ack = await this.$service.getTransferOrders({branch: this.branch});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.transferOrders = ack.data;
        }
        this.isBusy = false;
      },
      //**********************************************************
      async branchChanged(){
        await this.loadTransferOrders();
      },
      //**********************************************************
      async transferModal(id){
        this.loading = true;
        var ack = await this.$service.getTransferDetails({ id: id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.currTransfer = ack.data;
          $('#transferModal').modal('show');
        }
        this.loading = false;
      },
      //**********************************************************
      async acceptTransfer(){
        this.loading = true;
        await this._acceptTransfer();
        this.loading = false;
      },
      //**********************************************************
      async _acceptTransfer(){
        var ack = await this.$service.acceptTransfer({ id: this.currTransfer._id, notes: this.currTransfer.notes });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Transfer Accepted', 'success');
        $('#transferModal').modal('hide');
        await this.loadTransferOrders();
      },
      //**********************************************************
      async rejectTransfer(){
        this.loading = true;
        await this._rejectTransfer();
        this.loading = false;
      },
      //**********************************************************
      async _rejectTransfer(){
        var ack = await this.$service.rejectTransfer({ id: this.currTransfer._id, notes: this.currTransfer.notes });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Transfer Rejected', 'success');
        $('#transferModal').modal('hide');
        await this.loadTransferOrders();
      },
      //**********************************************************
      async viewReceipt(order_id){
        this.loading = true;
        await this.$refs.transfer_receipt.view(order_id);
        this.loading = false;
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  